import type { AxiosRequestConfig } from 'axios';
import urlcat from 'urlcat';
import type {
    ModuleConstructorProps,
    PopDisplays_LogFileImportSummary as PopDisplays_LogFileImportSummaryModel,
} from '../Types';
import { BaseEntityModuleFuncs } from './BaseEntityModuleFuncs';

const PopDisplays_LogFileImportSummary = ({
    endpoints,
    httpClient,
    baseUrl,
}: ModuleConstructorProps) => ({
    ...BaseEntityModuleFuncs<PopDisplays_LogFileImportSummaryModel>(
        { endpoints, httpClient, baseUrl },
        'PopDisplays_LogFileImportSummary',
    ),
    summary: (id: number, config?: AxiosRequestConfig) =>
        httpClient.get<{ data: PopDisplays_LogFileImportSummaryModel[] }>(
            urlcat(endpoints.Entities.PopDisplays_LogFileImportSummary.summary, { id }),
            config,
        ),
});

export default PopDisplays_LogFileImportSummary;
